export default __webpack_public_path__ + "static/media/Arrow-Left.3256a574.svg";